// export const BACKEND_URL = "https://tp-agents-backend-gihqqgucpa-ew.a.run.app";

// export const BACKEND_URL = "https://tp-agents-backend-xxx-ew.a.run.app/api";

export const BACKEND_URL = "https://tp-agents-backend-79591369583.europe-west1.run.app";